// AI 모델 선택 드롭다운 — 프롬프트 입력창에 붙는 LLM 스위처 (표시 전용, 실제 라우팅 없음)
import React, { useState, useRef, useEffect } from 'react';
import styles from './LLMSelector.module.css';

const MODELS = [
  { id: 'sarashina', name: 'Sarashina', color: '#EC4899', desc: '일본어 특화 · 고정밀 응답' },
  { id: 'claude',    name: 'Claude',    color: '#F97316', desc: '복잡한 추론 · 긴 문서 분석' },
  { id: 'chatgpt',   name: 'ChatGPT',   color: '#10B981', desc: '범용 질의 · 빠른 처리' },
  { id: 'gemini',    name: 'Gemini',    color: '#8B5CF6', desc: '멀티모달 · 이미지·데이터 분석' },
];

interface Props {
  dropUp?: boolean;
}

export default function LLMSelector({ dropUp = true }: Props) {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState('sarashina');
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const model = MODELS.find(m => m.id === current)!;

  return (
    <div className={styles.selector} ref={ref}>
      <button
        className={`${styles.trigger} ${open ? styles.triggerOpen : ''}`}
        onClick={() => setOpen(p => !p)}
        onMouseDown={e => e.stopPropagation()}
      >
        <span className={styles.dot} style={{ background: model.color }} />
        <span>{model.name}</span>
        <svg
          className={`${styles.arrow} ${open ? styles.arrowOpen : ''}`}
          width="12" height="12" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
        >
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </button>

      {open && (
        <div className={`${styles.dropdown} ${dropUp ? styles.dropUp : styles.dropDown}`}>
          {MODELS.map(m => (
            <div
              key={m.id}
              className={`${styles.option} ${m.id === current ? styles.optionSelected : ''}`}
              onMouseDown={e => e.stopPropagation()}
              onClick={() => { setCurrent(m.id); setOpen(false); }}
            >
              <span className={styles.optDot} style={{ background: m.color }} />
              <div className={styles.optInfo}>
                <div className={styles.optName}>{m.name}</div>
                <div className={styles.optDesc}>{m.desc}</div>
              </div>
              {m.id === current && (
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2.5" strokeLinecap="round">
                  <path d="M20 6L9 17l-5-5"/>
                </svg>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
